module.exports = __webpack_public_path__ + "fontawesome-webfont.24c601e721ebd8279d38.svg";


//////////////////
// WEBPACK FOOTER
// D:/project_chips/xosotravinh/xosotravinh_angular_client/src/assets/fonts/fontawesome-webfont.svg?v=4.6.3
// module id = ../../../../../src/assets/fonts/fontawesome-webfont.svg?v=4.6.3
// module chunks = styles